import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

export default function withAuth(ComponentToProtect) {
  return class extends Component {
    constructor() {
      super();
      this.state = {
        loading: true,
        redirect: false,
      };
    }

    componentDidMount() {
      this._isMounted = true;
      let gc_token = window.localStorage.getItem('gc_token');

      if (/^".*"$/.test(gc_token)) gc_token = gc_token.replace(/^"(.*)"$/, '$1');

      if (gc_token && gc_token.length > 0) {

        localStorage.setItem('gc_token', gc_token);

        fetch(`${process.env.REACT_APP_API_URL}/condition/admin`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'Authorization': localStorage.getItem('gc_token')
          }
        }).then((response) => {
          response.json().then((body) => {

            if (this._isMounted) {
              if ((body.err && body.err !== 'undefined') || (body.gcCode && body.gcCode !== 'undefined')) {
                localStorage.removeItem('gc_token');

                this.setState({loading: false, redirect: true});
              } else {
                this.setState({loading: false});
              }
            }

          });
        })

      } else {
        if (this._isMounted) {
          localStorage.removeItem('gc_token');

          this.setState({loading: false, redirect: true});
        }
      }
    }

    componentWillUnmount() {
      this._isMounted = false;
    }


    render() {
      const { loading, redirect } = this.state;
      if (loading) {
        return null;
      }
      if (redirect) {
        return <Redirect to="/login" />;
      }
      return (
        <React.Fragment>
          <ComponentToProtect {...this.props} />
        </React.Fragment>
      );
    }
  }
}